import { DrawerTemplateButton, DrawerActionButtonProps } from './drawerTemplateButton';
import { DrawerFooter, DrawerFooterProps } from '../drawerFooter';

export interface DrawerTemplateFooterProps extends DrawerFooterProps {
    buttons?: DrawerActionButtonProps[]
}

export const DrawerTemplateFooter: React.FC<DrawerTemplateFooterProps> = (props) => {
    const buttons = (): DrawerActionButtonProps[] => {
        if (props.buttons === null || props.buttons === undefined || props.buttons.length <= 0) {
            return [];
        }

        return props.buttons.filter(item => item.onClick !== null && item.onClick !== undefined)
    }

    if (buttons().length <= 0) {
        return null;
    }

    return (
        <DrawerFooter {...props}>
            <div className="container-fluid d-flex flex-row-reverse justify-content-between p-1">
                {buttons().map((item: DrawerActionButtonProps, index: number) => (
                    <DrawerTemplateButton key={"drawer_footer_button_" + index} {...item} />
                ))}
            </div>
        </DrawerFooter>
    );
};